/*eslint-env commonjs, amd */
/* global jQuery, migrateWarn, process */
/**
 * Polyfill jquery live
 */

 /*!
  * https://github.com/PrestaShop/jquery.live-polyfill
  *
  * Released under the MIT license
  */
  (function (factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define(['jquery'], factory);
    } else if (typeof exports === 'object') {
      // Node/CommonJS
      module.exports = factory(require('jquery'));
    } else {
      // Browser globals
      factory(jQuery);
    }
  }(function($) {

  var oldInit = $.fn.init

  $.fn.init = function(selector) {
    var args = Array.prototype.slice.call(arguments);

    if (typeof selector === 'string' && selector === '#' && typeof migrateWarn === 'function') {
      // JQuery( "#" ) is a bogus ID selector, but it returned an empty set before jQuery 3.0
      migrateWarn('jQuery(\'#\') is not a valid selector');
      args[0] = [];
    }

    var ret = oldInit.apply(this, arguments);
    ret.selector = typeof selector === 'string' ? selector : '';

    return ret;
  };

  $.fn.init.prototype = $.fn;

  if (typeof $.fn.live === 'undefined' || !($.isFunction($.fn.live))) {
    $.fn.extend({
      live: function (types, data, callback) {
        if (this.selector) {
          $(document).on(types, this.selector, data, callback);
        }
        if (process.env.NODE_ENV === 'development') {
          console.warn('jQuery.live() has been removed since jQuery v1.9, please use jQuery.on() instead.');
        }
        return this;
      }
    });
  }

  // Added polyfills for use within CA
  
  if (typeof $.fn.die === 'undefined' || !($.isFunction($.fn.die))) {
    $.fn.extend({
      die: function(types, fn) {
        if (this.selector) {
          $( this.context ).off( types, this.selector || "**", fn );
        }
        if (process.env.NODE_ENV === 'development') {
          console.warn('jQuery.die() has been removed since jQuery v1.9, please use jQuery.off() instead.');
        }
        return this;
      }
    });
  }

  if (typeof $.curCSS === 'undefined' || !($.isFunction($.curCSS))) {
    $.extend({
      curCSS: function(element, prop, val) {
        if (element) {
          $(element).css(prop, val);
        }
        if (process.env.NODE_ENV === 'development') {
          console.warn('jQuery.curCSS() has been removed since jQuery v1.8, please use jQuery.css() instead.');
        }

        return this;
      }
    });
  }

  
  if (typeof $.fn.size === 'undefined' || !($.isFunction($.fn.size))) {
    $.fn.extend({
      size: function(element) {
        $(element).length;

        if (process.env.NODE_ENV === 'development') {
          console.warn('jQuery.size() has been deprecated since jQuery v1.8 and will be removed in v3.0. Please use jQuery.length instead.');
        }

        return this;
      }
    });
  }

  // Not a full polyfill to encourage devs to use an alternate solution while avoiding undefined errors
  if (typeof $.browser === 'undefined') {
    $.extend({
      browser: {}
    });

    if (process.env.NODE_ENV === 'development') {
      console.warn('jQuery.browser has been removed in jQuery v1.9.');
    }
  }

  /*
  * Used to polyfill .data('events')
  * Copied from jQuery Migrate v.1.4.1
  */
  var oldFnData = $.fn.data;

  $.fn.data = function( name ) {
    var ret, evt,
      elem = this[0];

    // Handles 1.7 which has this behavior and 1.8 which doesn't
    if ( elem && name === "events" && arguments.length === 1 ) {
      ret = $.data( elem, name );
      evt = $._data( elem, name );
      if ( ( ret === undefined || ret === evt ) && evt !== undefined ) {
        if (process.env.NODE_ENV === 'development') {
          console.warn("jQuery.fn.data('events') has been removed in jQuery v1.9.");
        }
        return evt;
      }
    }
    return oldFnData.apply( this, arguments );
  };
}));